export default __webpack_public_path__ + "static/media/logo-white.dd9885e0.png";